<div class="alert alert-{{messageInfo.type}} alert-dismissible custom-file-alert" role="alert" *ngIf="messageInfo?.message?.length > 0">
  {{messageInfo?.message}}
  <button type="button" class="close" (click)="alertBarService.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>